import Asset from "@/bloks/atoms/Asset";
import type { SnackbarStoryblok } from "@/types/blok-types";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import styles from "./snackbar.module.css";

const Snackbar = ({ blok }: { blok: SnackbarStoryblok }) => {
  const { icon, primaryText, links } = blok;

  if (!icon && !primaryText && !links) {
    return <></>;
  }
  return (
    <nav className={`snackbar ${styles.snackbar}`}>
      <span className={`message-wrapper ${styles["message-wrapper"]}`}>
        {icon && <Asset asset={icon} />}
        <p>{primaryText}</p>
      </span>
      <span className={`links-wrapper ${styles["links-wrapper"]}`}>
        {links?.map((link) => (
          <StoryblokComponent blok={link} key={link._uid} />
        ))}
        {/* <CurrencyPicker /> */}
      </span>
    </nav>
  );
};

export default Snackbar;
